// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CKBH","content":"styles_content__1rHdb","tableWrap":"styles_tableWrap__mWGCk"};